module.exports = __webpack_public_path__ + "f89e2c64563ba8fde1492c3ba7bb81a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1_variable/public/picture/Stanley.jpg
// module id = 374
// module chunks = 0